<template>
  <div class="hold-transition">
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Reportes</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Hidrocarburos</li>
                  <li class="breadcrumb-item active">Consultas</li>
                  <li class="breadcrumb-item active">Reportes</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <h2 class="text-center text-dark display-4 mt-5">
              Tablero de Reportes
            </h2>
            <div class="row justify-content-center p-3">
              <div class="col-md-3 column">
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-guia-export"
                  >
                    <i class="fa fa-list text-olive fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">Exportar Guía</div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.exportGeneral')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-general-export"
                  >
                    <i class="fas fa-file-alt text-success fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">Reporte General</div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.ofertasExport')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-ofertas-export"
                  >
                    <i class="fab fa-buffer text-yellow fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">Lista Ofertas</div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.programacionExport'
                  )
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-programaciones-export"
                  >
                    <i class="fas fa-clipboard-list text-primary fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Lista Programaciones
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.solicitudExport')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-solicitudes-export"
                  >
                    <i class="fas fa-business-time text-purple fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Solicitudes Diarias
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.nominacionExport')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-nominacion"
                  >
                    <i class="fas fa-users text-blue fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Reporte Nominaciones
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.postulacionExport')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-postulacion-export"
                  >
                    <i class="fas fa-money-check text-warning fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Informe Postulaciones
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.exportConsolidado')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-consolidado-transporte-export"
                  >
                    <i class="fas fa-bus text-info fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Consolidado Transporte
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.enturneExport')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-enturne-export"
                  >
                    <i class="fas fa-sign-in-alt text-dark fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">Reporte Enturnes</div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.ticketsExport')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-ticket-export"
                  >
                    <i class="fas fa-ticket-alt text-danger fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">Exportar Ticket</div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.exportInspecciones'
                  )
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-inspecciones-export"
                  >
                    <i class="fas fa-file-signature text-success fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Reporte Inspecciones
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="$store.getters.can('hidrocarburos.reportes.adicionales')"
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-adicionales-export"
                  >
                    <i class="fas fa-plus-circle text-secondary fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Reporte Adicionales
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="$store.getters.can('hidrocarburos.reportes.informeGuias')"
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-guia-completa"
                  >
                    <i class="fa fa-list text-olive fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">Informe de Guías</div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can(
                    'hidrocarburos.ventanasOperaciones.regaliasExport'
                  )
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-regalia-export"
                  >
                    <i class="fas fa-handshake text-navy fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Reporte Regalias y Terceros
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.reporteCumplimiento'
                  )
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-cumplimiento"
                  >
                    <i class="fas fa-percent text-lightblue fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Reporte Cumplimiento
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.reporteCumplimiento'
                  )
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-consolidado-ticket"
                  >
                    <i class="fas fa-truck-moving text-orange fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Consolidado Transporte Ticket
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.reporteCargue')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-Diario-export"
                  >
                    <i class="fas fa-file-alt text-fuchsia fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Reporte Diario De Cargue
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can('hidrocarburos.reportes.reporteDescargue')
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-DiarioD-export"
                  >
                    <i class="fas fa-file-alt text-lime fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Reporte Diario De Descargue
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.exportReporteEcopetrol'
                  )
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-ecopetrol-export"
                  >
                    <i class="fas fa-file-alt text-teal fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">Reporte Ecopetrol</div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.exportReporteEcopetrol'
                  ) ||
                  $store.getters.can(
                    'hidrocarburos.reportes.exportReporteEscaner'
                  )
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-escaner-export"
                  >
                    <i class="fas fa-file-archive text-maroon fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">
                      Reporte Escáner Guías
                    </div>
                  </button>
                </div>
              </div>
              <div
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.exportReporteOperativo'
                  )
                "
                class="col-md-3 column"
              >
                <div class="card">
                  <button
                    type="button"
                    class="btn btn-default btn-block btn-lg shadow-sm"
                    data-toggle="modal"
                    data-target="#modal-form-reporte-operativo"
                  >
                    <i class="fa fa-list text-purple fa-2x"></i>
                    <div class="mt-2 text-lg text-dark">Reporte Operativo</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <ReporteOfertasExport ref="ReporteOfertasExport" />
    <ReporteNominacionExport ref="ReporteNominacionExport" />
    <ReporteGuiaExport ref="ReporteGuiaExport" />
    <ReporteProgramacionesExport ref="ReporteProgramacionesExport" />
    <ReporteSolicitudesExport ref="ReporteSolicitudesExport" />
    <ReporteGeneralExport ref="ReporteGeneralExport" />
    <PostulacionExport ref="PostulacionExport" />
    <ConsolidadoTransporteExport ref="ConsolidadoTransporteExport" />
    <ReporteEnturneExport ref="ReporteEnturneExport" />
    <ReporteTicketExport ref="ReporteTicketExport" />
    <ReporteInspeccionesExport ref="ReporteInspeccionesExport" />
    <ReporteAdicionalesExport ref="ReporteAdicionalesExport" />
    <ReporteGuiaCompleta ref="ReporteGuiaCompleta" />
    <ReporteRegaliaExport ref="ReporteRegaliaExport" />
    <reporte-cumplimiento-export ref="ReporteCumplimientoExport" />
    <ReporteDiarioDeCargueExport ref="ReporteDiarioDeCargueExport" />
    <ReporteDiarioDeDescargueExport ref="ReporteDiarioDeDescargueExport" />
    <ConsolidadoTransporteTicketExport
      ref="ConsolidadoTransporteTicketExport"
    />
    <ReporteEcopetrolExport ref="ReporteEcopetrolExport" />
    <ReporteEscanerGuiasExport ref="ReporteEscanerGuiasExport" />
    <ReporteOperativoExport ref="ReporteOperativoExport" />
  </div>
</template>

<script>
import ReporteGuiaExport from "./ReporteGuiaExport";
import ReporteNominacionExport from "./ReporteNominacionExport";
import ReporteOfertasExport from "./ReporteOfertasExport";
import ReporteProgramacionesExport from "./ReporteProgramacionesExport";
import ReporteSolicitudesExport from "./ReporteSolicitudesExport";
import ReporteGeneralExport from "./ReporteGeneralExport";
import PostulacionExport from "./PostulacionExport";
import ConsolidadoTransporteExport from "./ConsolidadoTransporteExport";
import ReporteEnturneExport from "./ReporteEnturneExport";
import ReporteTicketExport from "./ReporteTicketExport";
import ReporteInspeccionesExport from "./ReporteInspeccionesExport";
import ReporteAdicionalesExport from "./ReporteAdicionalesExport";
import ReporteGuiaCompleta from "./ReporteGuiaCompleta";
import ReporteRegaliaExport from "./ReporteRegaliaExport";
import ReporteDiarioDeCargueExport from "./ReporteDiarioDeCargueExport";
import ReporteDiarioDeDescargueExport from "./ReporteDiarioDeDescargueExport";
import axios from "axios";
import ReporteCumplimientoExport from "./ReporteCumplimientoExport.vue";
import ConsolidadoTransporteTicketExport from "./ConsolidadoTransporteTicketExport";
import ReporteEcopetrolExport from "./ReporteEcopetrolExport";
import ReporteEscanerGuiasExport from "./ReporteEscanerGuiasExport";
import ReporteOperativoExport from "./ReporteOperativoExport";
export default {
  name: "ReporteIndex",
  data() {
    return {
      cargando: false,
      sitio_origen: {},
      sitio_destino: {},
      listasForms: {
        productos_liquidos: [],
        sitiosOrigenes: [],
        sitiosDestinos: [],
        empresas: [],
        listaConsultas: [],
      },
    };
  },
  components: {
    ReporteGuiaExport,
    ReporteNominacionExport,
    ReporteOfertasExport,
    ReporteProgramacionesExport,
    ReporteSolicitudesExport,
    ReporteGeneralExport,
    PostulacionExport,
    ConsolidadoTransporteExport,
    ReporteEnturneExport,
    ReporteTicketExport,
    ReporteInspeccionesExport,
    ReporteAdicionalesExport,
    ReporteGuiaCompleta,
    ReporteRegaliaExport,
    ReporteCumplimientoExport,
    ConsolidadoTransporteTicketExport,
    ReporteDiarioDeCargueExport,
    ReporteDiarioDeDescargueExport,
    ReporteEcopetrolExport,
    ReporteEscanerGuiasExport,
    ReporteOperativoExport,
  },

  methods: {
    getProductoLiquido() {
      axios.get("api/hidrocarburos/Productos/lista").then((response) => {
        this.$refs.ReporteGeneralExport.listasForms.productos_liquidos =
          response.data;
        this.$refs.ReporteGuiaExport.listasForms.productos_liquidos =
          response.data;
        this.$refs.ConsolidadoTransporteExport.listasForms.productos_liquidos =
          response.data;
        this.$refs.ReporteEnturneExport.listasForms.productos_liquidos =
          response.data;
        this.$refs.ReporteTicketExport.listasForms.productos_liquidos =
          response.data;
        this.$refs.ReporteGuiaCompleta.listasForms.productos_liquidos =
          response.data;
        this.$refs.ReporteRegaliaExport.listasForms.productos_liquidos =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.productos_liquidos =
          response.data;
        this.$refs.ReporteEcopetrolExport.listasForms.productos_liquidos =
          response.data;
      });
    },
    getSitios() {
      axios.get("api/admin/sitios/lista").then((response) => {
        this.$refs.ReporteGeneralExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteGuiaExport.listasForms.sitiosOrigenes = response.data;
        this.$refs.ReporteSolicitudesExport.listasForms.sitios = response.data;
        this.$refs.ReporteGeneralExport.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteGuiaExport.listasForms.sitiosDestinos = response.data;
        this.$refs.PostulacionExport.listasForms.sitios = response.data;
        this.$refs.ConsolidadoTransporteExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ConsolidadoTransporteExport.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteEnturneExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteEnturneExport.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteTicketExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteTicketExport.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteAdicionalesExport.listasForms.sitios = response.data;
        this.$refs.ReporteGuiaCompleta.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteGuiaCompleta.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteRegaliaExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteRegaliaExport.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteDiarioDeCargueExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteDiarioDeCargueExport.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteEcopetrolExport.listasForms.sitiosDestinos =
          response.data;
        this.$refs.ReporteEcopetrolExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteEscanerGuiasExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteOperativoExport.listasForms.sitiosOrigenes =
          response.data;
        this.$refs.ReporteOperativoExport.listasForms.sitiosDestinos =
          response.data;
      });
    },
    getEmpresas() {
      axios.get("/api/admin/empresas/lista").then((response) => {
        this.$refs.ReporteGeneralExport.listasForms.empresas = response.data;
        this.$refs.ConsolidadoTransporteExport.listasForms.empresas =
          response.data;
        this.$refs.ReporteGuiaExport.listasForms.empresas = response.data;
        this.$refs.PostulacionExport.listasForms.empresas = response.data;
        this.$refs.ReporteEnturneExport.listasForms.empresas = response.data;
        this.$refs.ReporteTicketExport.listasForms.empresas = response.data;
        this.$refs.ReporteInspeccionesExport.listasForms.empresas =
          response.data;
        this.$refs.ReporteAdicionalesExport.listasForms.empresas =
          response.data;
        this.$refs.ReporteGuiaCompleta.listasForms.empresas = response.data;
        this.$refs.ReporteRegaliaExport.listasForms.empresas = response.data;
        this.$refs.ReporteDiarioDeCargueExport.listasForms.empresas =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.empresas =
          response.data;
        this.$refs.ReporteEcopetrolExport.listasForms.empresas = response.data;
        this.$refs.ReporteEscanerGuiasExport.listasForms.empresas =
          response.data;
        this.$refs.ReporteOperativoExport.listasForms.transportadoras =
          response.data;
      });
    },
    getTipoOperacion() {
      axios.get("/api/lista/57").then((response) => {
        this.$refs.ReporteGuiaExport.listasForms.tipo_operacion = response.data;
        this.$refs.ReporteGuiaCompleta.listasForms.tipo_operacion =
          response.data;
      });
    },
    getPlaneaciones() {
      axios.get("/api/hidrocarburos/ofertas/lista").then((response) => {
        this.$refs.ReporteOfertasExport.listasForms.planeaciones =
          response.data;
      });
    },
    getNominaciones() {
      this.cargando = true;
      axios.get("/api/hidrocarburos/nominacion/list").then((response) => {
        this.$refs.ReporteSolicitudesExport.listasForms.nominaciones =
          response.data;
      });
    },
    getTiposCombustibles() {
      axios.get("/api/lista/24").then((response) => {
        this.$refs.ReporteGuiaExport.listasForms.tiposCombustible =
          response.data;
        this.$refs.ReporteGeneralExport.listasForms.tiposCombustible =
          response.data;
        this.$refs.PostulacionExport.listasForms.tiposCombustible =
          response.data;
        this.$refs.ReporteGuiaCompleta.listasForms.tiposCombustible =
          response.data;
        this.$refs.ReporteInspeccionesExport.listasForms.tiposCombustible =
          response.data;
        this.$refs.ReporteEcopetrolExport.listasForms.tiposCombustible =
          response.data;
      });
    },
    getNominacionesC() {
      axios
        .get("/api/hidrocarburos/nominacion/lista")
        .then((response) => {
          this.$refs.ReporteNominacionExport.listasForms.nominaciones =
            response.data;
          this.$refs.ReporteCumplimientoExport.listasForms.nominaciones =
            response.data;
        });
    },
    getTipoRuta() {
      axios.get("/api/lista/48").then((response) => {
        this.$refs.PostulacionExport.listasForms.tipo_ruta = response.data;
        this.$refs.ReporteAdicionalesExport.listasForms.tipo_rutas =
          response.data;
      });
    },
    getTipoVehiculos() {
      axios.get("api/admin/tiposVehiculos/lista").then((response) => {
        this.$refs.ReporteDiarioDeCargueExport.listasForms.tiposVehiculos =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.tiposVehiculos =
          response.data;
        this.$refs.ReporteEcopetrolExport.listasForms.tiposVehiculos =
          response.data;
      });
    },
    getEstados() {
      axios.get("/api/lista/63").then((response) => {
        this.$refs.ReporteAdicionalesExport.listasForms.estados = response.data;
      });
    },
    getVehiculos() {
      axios.get("/api/admin/vehiculos/lista").then((response) => {
        this.$refs.ReporteDiarioDeCargueExport.listasForms.placas =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.placas =
          response.data;
        this.$refs.ReporteEcopetrolExport.listasForms.placas = response.data;
        this.$refs.ReporteOperativoExport.listasForms.vehiculos =
          response.data;
      });
    },
    getRemolques() {
      axios.get("/api/admin/remolques/lista").then((response) => {
        this.$refs.ReporteDiarioDeCargueExport.listasForms.remolques =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.remolques =
          response.data;
        this.$refs.ReporteOperativoExport.listasForms.remolques =
          response.data;
      });
    },
    getGuias() {
      axios.get("/api/admin/guias/lista").then((response) => {
        this.$refs.ReporteDiarioDeCargueExport.listasForms.n_guia =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.n_guia =
          response.data;
      });
    },
    getBloques() {
      axios.get("/api/admin/bloques/lista").then((response) => {
        this.$refs.ReporteDiarioDeCargueExport.listasForms.bloques =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.bloques =
          response.data;
        this.$refs.ReporteOperativoExport.listasForms.bloques =
          response.data;
      });
    },
    getConductor() {
      axios.get("api/admin/conductores/lista").then((response) => {
        this.$refs.ReporteDiarioDeCargueExport.listasForms.conductores =
          response.data;
        this.$refs.ReporteDiarioDeDescargueExport.listasForms.conductores =
          response.data;
        this.$refs.ReporteEcopetrolExport.listasForms.conductores =
          response.data;
        this.$refs.ReporteOperativoExport.listasForms.conductores =
          response.data;
      });
    },
    getListaConsulta() {
      axios.get("/api/lista/47").then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].numeracion != 2) {
            this.$refs.ReporteEscanerGuiasExport.listasForms.listaConsultas.push(
              response.data[i]
            );
          }
        }
      });
    },
  },

  beforeMount() {
    this.getSitios();
    this.getProductoLiquido();
    this.getEmpresas();
    this.getTipoOperacion();
    this.getPlaneaciones();
    this.getTiposCombustibles();
    this.getNominaciones();
    this.getNominacionesC();
    this.getTipoRuta();
    this.getEstados();
    this.getVehiculos();
    this.getRemolques();
    this.getTipoVehiculos();
    this.getBloques();
    this.getConductor();
    this.getListaConsulta();
  },
};
</script>
